import { styled } from "@mui/material";

export const DataTableStyled = styled("table")`
  border: 1px solid black;
  margin: 0 12px 12px 12px;
  min-width: calc(100% - 24px);
  position: relative;
  overflow-x: scroll;

  thead th {
    border: 1px solid black;
    padding: 1px 4px;
    position: sticky;
    top: 0;
    z-index: 4;
  }

  thead {
    z-index: 2;
  }

  tbody {
    overflow: hidden;
    z-index: 1;
  }

  tr td:first-of-type,
  tr th:first-of-type {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  thead th:first-of-type {
    z-index: 10;
  }

  tr:hover td {
    background: rgba(240, 240, 240, 1);
  }

  td,
  th {
    background: white;
    border: 1px solid black;
    padding: 1px 4px;
    text-wrap: nowrap;
  }
`;
